(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityPharmacy', FacilityPharmacy);

    FacilityPharmacy.$inject = ['$resource'];

    function FacilityPharmacy ($resource) {
        var resourceUrl =  'api/facility-pharmacy/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/facility-pharmacy/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
